import { createFileRoute } from '@tanstack/react-router';
import { i18next } from '@frontend/i18n';
import { KioskHomePage } from '../pages';

export const Route = createFileRoute('/kiosk_/$locationId')({
  component: KioskHomePage,
  head: () => ({
    meta: [
      {
        title: i18next.t('Welcome', { ns: 'digital-forms-experience' }),
      },
    ],
  }),
});
